module.exports = __webpack_public_path__ + "img/distribute.2ef95089.png";